import { render, staticRenderFns } from "./BoxPager.vue?vue&type=template&id=b8faa882&scoped=true&"
import script from "./BoxPager.vue?vue&type=script&lang=js&"
export * from "./BoxPager.vue?vue&type=script&lang=js&"
import style0 from "./BoxPager.vue?vue&type=style&index=0&id=b8faa882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8faa882",
  null
  
)

export default component.exports